import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, GlobalMessageService, GlobalMessageType, OccEndpointsService, RoutingService } from "@spartacus/core";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { CustomAddToCartService } from "src/app/custom-add-to-cart/custom-add-to-cart.service";
import { CustomProdPgService } from "src/app/custom-prod-pg/custom-prod-pg.service";
import { CartEntryService } from "src/app/shared/services/cart-entry.service";
import { SharedService } from "src/app/shared/services/shared.service";
import { ProductUtils } from "src/app/shared/utils/productUtils";
import * as _ from 'underscore';

@Component({
    selector: 'app-view-and-reorder-products',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './view-and-reorder-products.component.html',
    styleUrls: ['./view-and-reorder-products.component.scss'],
    standalone: false
})
export class ViewAndReorderProductsComponent implements OnInit {
  @Input() reoderProductList;
  @Input() selectedLocations;
  @Input() cartId;
  @Input() userDetails;
  disabled: boolean = true;
  cartItemsSub: Subscription;
  cartItems: any = [];
  updatedCartSub: Subscription;
  updateErrorSub: Subscription;
  b2bUnitId: any;
  userAccountDetailsSub: any;
  cartProdDetails: any;
  checkoutCartDetailsSub: any;
  checkoutCartFailedSub: any;
  checkoutFlag: boolean;
  addToCartFlag: boolean;
  baseUrl: string;
  defaultImg = 'img/sanofi_missing_product.jpg';
  blockOrder: boolean;
  isFormularyCustomer = false;
  isYFauthorized = false;

  constructor(
    private readonly occEndPoint: OccEndpointsService,
    private readonly cd: ChangeDetectorRef,
    private readonly baseSiteService: BaseSiteService,
    public readonly activeModal?: NgbActiveModal, private readonly plpService?: CustomProdPgService,
    private readonly globalMessage?: GlobalMessageService, private readonly addToCartService?: CustomAddToCartService,
    private readonly route?: RoutingService, private readonly router?: Router,
    private readonly sharedService?: SharedService,
    private readonly cartEntryService?: CartEntryService

  ) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });

  }
  baseSiteId: string;
  ngOnInit(): void {
    this.getUserAccountData();
    this.isFormularyCustomer =
      this.sharedService.getLocalStorage('formularyCustomer');
    this.isYFauthorized = this.sharedService.getLocalStorage('YFAuthorized');
    this.blockOrder = this.sharedService.getLocalStorage('blockOrder');
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    this.cd.detectChanges();
  }
  performQuantityComputation(operator, idData, reorderData): void {
    this.disabled = false;
    ProductUtils.computeQuantityForAllocated(operator, idData, reorderData.quantityPerUnit,
      reorderData.uom, 9999);
    let uniteAdded = [];
    this.reoderProductList.forEach(element => {
      const inputElement = document.getElementById(
        `prodQuantity${element.code}`
      ) as HTMLInputElement;
      if (+inputElement.value > 0) {
        uniteAdded.push('yes');
      }
    });
    uniteAdded.length > 0 ? this.disabled = false : this.disabled = true;
  }
  getContractPrice(data) {
    return data !== undefined ? data?.contractPrice?.formattedValue : '$--';
  }
  closeModal() {
    this.activeModal.dismiss();
  }
  addToCart(value) {
    const FSProds = JSON.parse(this.sharedService.getLocalStorage('futureShipProducts'));
    if (value === 'addToCart') {
      this.addToCartFlag = true;
    } else {
      this.checkoutFlag = true;
    }
    let filteredAvailableData = this.reoderProductList.filter((element) =>
    (this.userDetails && (element?.flu ? element.shipNow?.toLowerCase() === 'on' : true)
      && this.prodAvailableForOrder(element) &&
      (this.isFormularyCustomer ? element.formularyProduct : true) &&
      (element?.yellowFever ? this.isYFauthorized : true)));
    filteredAvailableData.forEach(element => {
      const inputElement = document.getElementById(
        `prodQuantity${element.code}`
      ) as HTMLInputElement;
      if (+inputElement.value > 0) {
        let params
        params = {
          basePrice: { value: element?.price?.value.toString() },
          product: { code: element.code },
          quantity: inputElement?.value,
          selectedLocations: [this.selectedLocations[0]?.accountNumber],
          contractInfo: { contractId: "", contractDesc: "", contractPrice: { value: 0 } }
        }
        if (!!FSProds?.length && FSProds.includes(element.code)) params['futureShipExpProd'] = true;
        if (element.contract !== undefined && element.contract !== '') {
          params.contractInfo = element.selectedContractGroup;
          params.basePrice = { value: "0" }
        }
        this.UpdateCartDetails(params, value);
      }
    });
  }
  UpdateCartDetails(params, value) {
    this.plpService.updateCart(params, this.userDetails?.uid, this.cartId);
    this.updatedCartSub = this.plpService.cartDetailsUpdate$.subscribe((res) => {
      if (res) {
        if (value === 'addToCart') {
          this.addToCartFlag = false;
          this.closeModal();
        } else {
          this.checkoutFlag = true;
          this.checkout()
        }
      }
    });
    this.updateErrorSub = this.plpService.updateError$.subscribe((res) => {
      if (res) {
        this.globalMessage.add(res[0].message, GlobalMessageType.MSG_TYPE_ERROR);
        this.addToCartFlag = false;
        this.checkoutFlag = false;
        this.closeModal();

      }
    })
  }
  checkout() {
    const params = {
      "b2bUnitId": this.b2bUnitId,
      "deliveryDates": []
    }
    this.checkoutFlag = true;
    this.addToCartService.checkoutCartPage(params, this.cartId);
    this.checkoutCartDetailsSub = this.addToCartService.checkoutCartDetails$.subscribe((res) => {
      if (res) {
        this.checkoutFlag = false;
        this.cartEntryService.goToCart();
        this.closeModal();
      }
    });
    this.checkoutCartFailedSub = this.addToCartService.checkoutCartFailed$.subscribe((res) => {
      if (res) {
        this.checkoutFlag = false;
        this.globalMessage.add(res[0].message, GlobalMessageType.MSG_TYPE_ERROR);
        this.closeModal();
      }
    });
  }
  ngOnDestroy() {
    this.updatedCartSub?.unsubscribe();
    this.checkoutCartDetailsSub?.unsubscribe();
    this.updateErrorSub?.unsubscribe();
    this.checkoutCartFailedSub?.unsubscribe();
  }
  getUserAccountData(): void {
    this.userAccountDetailsSub = this.addToCartService.userAccountDetails$.subscribe((userDataget) => {
      if (userDataget) {
        this.b2bUnitId = userDataget?.res?.uid;
        this.cd.detectChanges();
      }
    });

  }
  navigatePDP(code) {
    this.route.go([`/product/${code}/${code}`]);
    this.closeModal();
  }
  getImage(product: []) {
    let tempImg;
    if (product['images'] && product['images'].length > 0) {
      const imagesFormat = _.clone(
        _.findWhere(product['images'], { format: 'thumbnail' })
      );
      if (imagesFormat) {
        imagesFormat.url = `${this.baseUrl}${imagesFormat?.url}`;
      }
      tempImg = imagesFormat.url;
    } else {
      tempImg = this.defaultImg;
    }
    return tempImg;
  }
  prodAvailableForOrder(prod) {
    return (
      !prod.unavailable &&
      prod.orderable &&
      prod.available &&
      !prod.discontinued
    );
  }
  errorMessages(product) {
    let messages = [];
    if (product.unavailable) {
      messages.push('This product is currently unavailable');
    }
    else if (product.discontinued && product?.discontinuedText != null && product?.discontinuedText !== '') {
      messages.push(product?.discontinuedText)
    } else {
      !product.orderable &&
        messages.push('This product is no longer orderable');
      !product.available &&
        messages.push('This product is temporarily out of stock');
      !product.dating &&
        messages.push('Product may have less than 6 months dating.');
      product.discontinued &&
        messages.push('This product has been discontinued');
    }

    return messages;
  }
  unitValue(code) {
    let val = (document.getElementById(`prodQuantity${code}`) as HTMLInputElement).value;
    return (val != '0') ? true : false;
  }
}
